// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__7uT_1","inputDescription":"styles_inputDescription__1tL27"};